import React from "react";

import PropTypes from "prop-types";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MessagesUsersTabs from "./MessagesUsersTabs";

import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import DonationMessageCard from "./DonationMessageCard";
import {
  query,
  collection as firebaseCollection,
  onSnapshot,
  orderBy,
  where,
  getCountFromServer,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";
import { DEFAULT_COVER_URL } from "../../common/enum";

function TabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ ...sx }}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const MessagePanel = ({
  drawerState,
  toggleDrawer,
  setMessageUnReadCount,
  donationEntityId,
  donationId,
  t,
}) => {
  const [value, setValue] = React.useState(0);
  const [entities, setEntities] = React.useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const getData = () => {
      let q;

      q = query(
        firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
        
        donationId && where("donationId", "==", donationId),
        orderBy("updatedDate", "desc")
      );

      const unsub = onSnapshot(q, async (snap) => {
        const arr = [];
        for (let doc of snap.docs) {
          arr.push({
            ...doc.data(),
          });
        }
        setEntities([...arr]);
      });
      return () => {
        unsub();
      };
    };
    profile?.userId && getData();
  }, [profile, donationEntityId, donationId]);

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: {
          width: "50%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        },
      }}
    >
      <Button
        sx={{
          position: "fixed",
          right: "51%",
          top: 10,
          zIndex: 1,
          minWidth: 0,
          padding: "4px",
          borderRadius: "4px",
          backgroundColor: "#ffc3c3",
          "&:hover": {
            backgroundColor: "#ffc3c3",
          },
          "@media (max-width:900px)": {
            right: "1%",
          },
        }}
        onClick={() => toggleDrawer(false)}
      >
        <CloseOutlinedIcon color="error" />
      </Button>
      <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex" }}>
        <MessagesUsersTabs
          value={value}
          handleChange={handleChange}
          user={entities}
        />
        {entities.length === 0 && (
          <Typography variant="body1" sx={{ m: "auto" }}>
            {t("noChat")}
          </Typography>
        )}
        {entities.length > 0 &&
          entities.map((item, i) => (
            <TabPanel
              value={value}
              index={i}
              key={item.userRegistrationId}
              sx={{ width: "100%" }}
            >
              <Box
                sx={{
                  height: "110px",
                  backgroundImage: `url(${
                    item.bannerImage === "string" || item.bannerImage === null
                      ? DEFAULT_COVER_URL
                      : item.bannerImage
                  }),url(${DEFAULT_COVER_URL})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  position: "relative",
                  width: 1,
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "110px",
                    bgcolor: "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      position: "absolute",
                      color: "white",
                      left: "5%",
                      right: "0",
                      bottom: "30%",
                      fontSize: "1.50rem!important",
                      "@media (max-width:470px)": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        width: "90%",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    {item.entityName}
                  </Typography>
                  {item?.updatedDate !== undefined &&
                    item?.updatedDate !== null && (
                      <Typography
                        variant="body2"
                        sx={{
                          color: "white",
                          position: "absolute",
                          left: "5%",
                          right: "0",
                          bottom: "10%",
                          fontFamily: "Poppins",
                          fontSize: "1rem!important",
                          textDecoration: "underline",
                          "@media (max-width:470px)": {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            width: "90%",
                            whiteSpace: "nowrap",
                          },
                        }}
                      >
                        {" "}
                        <span>
                          {t("lastMessageReceived")}{" "}
                          {item?.updatedDate
                            .toDate()
                            .toLocaleDateString("pt-PT")}
                        </span>
                      </Typography>
                    )}
                </Box>
              </Box>
              <DonationMessageCard
                entityDonation={item}
                donationId={donationId}
                t={t}
              />
            </TabPanel>
          ))}
      </Box>
    </Drawer>
  );
};

export default MessagePanel;
